import parser from './parser/parser.vue'
import activiti from './activiti/activiti.vue'
import resources from './resources/resources.vue'
import tasks from './tasks/tasks.vue'
import proc from './proc/proc.vue'


// инструменты
import filter from './proc/filter/filter.vue'
import scripts from './proc/scripts/scripts.vue'
import msg from './proc/msg/msg.vue'
import posts from './proc/posts/posts.vue'

// ресурсы
import accounts_info from './resources/fullinfo/wrapper.vue'
import accounts from './resources/accounts/accounts.vue'
import friends_accounts from './resources/accounts/accounts.vue'
import antigate from './resources/antigate/antigate.vue'
import telega from './resources/telega/telega.vue'

// действия
import pagesWrapper from './tasks/pages/pagesWrapper.vue'
import contentWrapper from './tasks/content/pagesWrapper.vue'
import publicsWrapper from './tasks/publics/pagesWrapper.vue'

// активность
import activitis from './activiti/proc/proc.vue'
import pars_groups from './activiti/groups/pars_groups.vue'
import pars_pages from './activiti/pages/pars_pages.vue'
import pars_likes from './activiti/likes/pars_likes.vue'


// парсер
import parser_groups from './parser/pars_groups.vue'
import pages_search from './parser/pages_search.vue'
import parser_pages from './parser/pars_pages.vue'
import pars_topics from './parser/pars_topics.vue'
import pars_video from './parser/pars_video.vue'
import pars_posts from './parser/pars_posts.vue'
import filters from './parser/filters.vue'
import history from './parser/history/history.vue'

// логин и прочие инструменты
import auths from './auth/auth.vue'
import login from './auth/login.vue'




export const routes = [
{
  path: '/',
  component: parser,
},

{
  path: '/auths',
  component: auths,
  meta: {title: 'Добавление сервера'},
  children:[
    {
    path: '/',
    name: 'auths',
    component: login,
    meta: {title: 'Список серверов'}
    }
  ],
},



{
  path: '/parser',
  component: parser,
  children: [
    {
      path: '/',
      name: 'parser_groups',
      component: parser_groups,
      meta: {title: 'Парсер сообществ'}
    },
    {
      path: 'pages_search',
      name: 'pages_search',
      component: pages_search,
      meta: {title: 'Поиск страниц'},
    },
    {
      path: 'parser_pages',
      name: 'parser_pages',
      component: parser_pages,
      meta: {title: 'Парсер / Сбор страниц '},
    },
    {
      path: 'pars_topics',
      name: 'pars_topics',
      component: pars_topics,
      meta: {title: 'Парсер обсуждений'},
    },
    {
      path: 'pars_video',
      name: 'pars_video',
      component: pars_video,
      meta: {title: 'Парсер / поиск видео '},
    },
    {
      path: 'pars_posts',
      name: 'pars_posts',
      component: pars_posts,
      meta: {title: 'Парсер постов'},
    },
    {
      path: 'filters',
      name: 'filters',
      component: filters,
      meta: {title: 'Фильтрация результатов'},
    },
    {
      path: 'history',
      name: 'history',
      component: history,
      meta: {title: 'Сохраненные процессы парсера'},
    },

  ],
},




{
  path: '/activiti',
  component: activiti,

  children: [
    {
      path: '/',
      name: 'proc',
      component: activitis,
      meta: {title: 'Авто обновление  активности '},

    },
    {
      path: 'content',
      name: 'pars_groups',
      component: pars_groups,
      meta: {title: 'Новые подписки сообществ'},
    },
    {
      path: 'publics',
      name: 'pars_pages',
      component: pars_pages,
      meta: {title: 'Новые подписки, друзя страниц'},
    },
    {
      path: 'pars_likes',
      name: 'pars_likes',
      component: pars_likes,
      meta: {title: 'Новые лайки постов сообществ'},
    },

  ],
},






{
  path: '/resources',
  component: resources,
  children: [
    {
      path: 'accounts_info',
      name: 'accounts_info',
      component: accounts_info,
      meta: {title: 'Общая информация и настройки аккаунтов'},
    },
    {
      path: '/',
      name: 'accounts',
      component: accounts,
      meta: {title: 'Аккаунты вк',grId:1},
    },
    {
      path: 'friends_accounts',
      name: 'friends_accounts',
      component: accounts,
      meta: {title: 'Аккаунты вк для заявок в друзья',grId:3},
    },
    {
      path: 'autoreg_accounts',
      name: 'autoreg_accounts',
      component: accounts,
      meta: {title: 'Аккаунты - Автореги',grId:2},
    },
    {
      path: 'others_accounts',
      name: 'others_accounts',
      component: accounts,
      meta: {title: 'Дополнительный список аккаунтов',grId:4},
    },
    {
      path: 'antigate',
      name: 'antigate',
      component: antigate,
      meta: {title: 'Антигейт - решение капчи'},
    },
    {
      path: 'telega',
      name: 'telega',
      component: telega,
      meta: {title: 'Инструменты управления, телеграм бот'},
    },

  ],
},





{
  path: '/tasks',
  component: tasks,
  children: [
    {
      path: '/',
      name: 'pages',
      component: pagesWrapper,
      meta: {title: 'Действия над страницами'},
    },
    {
      path: 'content',
      name: 'content',
      component: contentWrapper,
      meta: {title: 'Действия над контентом'},
    },
    {
      path: 'publics',
      name: 'publics',
      component: publicsWrapper,
      meta: {title: 'Действия в сообществах'},
    },

  ],
},



{
  path: '/proc',
  component: proc,
  children: [
    {
      path: '/filter',
      name: 'filter',
      component: filter,
      meta: {title: 'Фильтр'},
    },
    {
      path: '/msg',
      name: 'msg',
      component: msg,
      meta: {title: 'Сообщения'},
    },
    {
      path: '/scripts',
      name: 'scripts',
      component: scripts,
      meta: {title: 'Скрипты'},
    },
    {
      path: '/',
      name: 'posts',
      component: posts,
      meta: {title: 'Список моих постов'},
    },

  ],
},




{
  path: '/*',
  component: parser
}
]
